import { Injectable } from "@angular/core"
import { AngularFirestore } from "@angular/fire/firestore"
import { AngularFireStorage, AngularFireUploadTask } from "@angular/fire/storage"
import { UploadTaskSnapshot } from "@angular/fire/storage/interfaces"
import * as firebase from "firebase/app"
import { Observable } from "rxjs"
import { finalize, tap } from "rxjs/operators"

export interface UploadFileInfo {
  path: string
  size: number
  url: string
}

@Injectable({
  providedIn: "root",
})
export class FileUploadService {
  public task: AngularFireUploadTask
  public percentage: Observable<number>

  constructor(private storage: AngularFireStorage) {}

  public async uploadFile(file: File, path: string, update: boolean = false): Promise<UploadFileInfo> {
    this.task = update
      ? this.storage.ref(path).put(file)
      : this.storage.upload(path, file)

    this.percentage = this.task.percentageChanges()

    return this.task
      .then(async snap => {
        const url = await this.storage.ref(path).getDownloadURL().toPromise()
        return { path, size: snap.totalBytes, url }
      })
  }

  public async deleteFile(filePath: string): Promise<boolean> {
    return this.storage.ref(filePath).delete().toPromise()
  }

  public async updateFile(previousPath: string, path: string, file: File): Promise<UploadFileInfo> {
    const isSamePath = path === previousPath
    const fileUploaded = await this.uploadFile(file, path, !isSamePath)
    if (!isSamePath) {
      await this.deleteFile(previousPath)
    }

    return fileUploaded
  }

  public isActive(snapshot: firebase.storage.UploadTaskSnapshot): boolean {
    return snapshot.state === firebase.storage.TaskState.RUNNING
        && snapshot.bytesTransferred < snapshot.totalBytes
  }
}
